define.alias("shared/components/shared/color-picker/selector", "calendar/components/shared/color-picker/selector");